
enum RealTimeMessagingEvents {
    BROADCAST_MESSAGE = 'broadcastMessage',
    BULK_SEARCH_CHANGED_EVENT = 'bulkSearchChanged',
    BULK_SUBSCRIPTION_CHANGED_EVENT = 'bulkSubscriptionChanged',
    CHAT_EVENT = 'chat',
    COMMUNICATION_CHANNELS_CHANGED_EVENT = 'communicationChannelsChanged',
    CONTACTS_CHANGED_EVENT = 'contactsChanged',
    DATA_MODEL_ACTIVATEABLE_EVENT = 'dataModelActivateable',
    DATA_MODEL_CHANGED_EVENT = 'dataModelChanged',
    DATA_MODEL_INVALID_EVENT = 'dataModelInvalid',
    DATA_MODEL_TEMPLATE_INVALID_EVENT = 'dataModelTemplateInvalid',
    EXPORT_SUMMARY_CHANGED_EVENT = 'exportSummaryChanged',
    FINISHED_VIRUS_SCAN_ON_ASSET = 'finishedVirusScanOnAsset',
    IMPORT_SUMMARY_CHANGED_EVENT = 'importSummaryChanged',
    ITEM_CHANGED_EVENT = 'itemChanged',
    ITEM_EDITED_EVENT = 'itemEdited',
    MASS_UPDATE_SUMMARY_CHANGED_EVENT = 'massUpdateSummaryChanged',
    MESSAGING_ASSET_CHANGED_EVENT = 'messagingAssetChanged',
    NEAR_ITEM_LIMIT_EVENT = 'nearItemLimit',
    NEWS_STREAM_CHANGED_EVENT = 'newsStreamChanged',
    ORGANIZATION_VERIFICATION_CHANGED_EVENT = 'organizationVerificationChanged',
    PUBLICATION_JOB_CHANGED_EVENT = 'publicationJobChanged',
    PUBLICATION_TASK_CHANGED_EVENT = 'publicationTaskChanged',
    TASK_ASSIGNED_EVENT = 'taskAssigned',
    USERGROUPS_CHANGED = 'userGroupsChanged',
    VALIDATION_FINISHED_EVENT = 'validationFinished',
    VALIDATION_TASK_CHANGED_EVENT = 'validationTaskChanged',
}

enum RealTimeMessagingActions {
    ITEM_EDITED = 'itemEdited',
    REGISTERED = 'registered',
    UNREGISTERED = 'unregistered',
}

export { RealTimeMessagingActions, RealTimeMessagingEvents };
